/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { getClientReportsData } from 'state/actions/reportsState/reports_status';
import { removeMessage } from '@insticator/insticator-ui'; // iui-state
// component
import Reports from 'pages/dashboard/reports/reports';



/* ========== ~~~~~~~~~~ REPORTS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ appStatus, sessionStatus, reportsState }) => ({
	accountUUID: sessionStatus.accountUUID,
    currentPage: appStatus.currentPage,
    reportMode: reportsState.reportsStatus.mode,
    reportsPermitted: sessionStatus.permissions.includes('home.adMetrics'),
    permissionsReceived: sessionStatus.permissionsReceived,
    isDataReceived: reportsState.reportsStatus.isDataReceived,
    reportName: reportsState.selectedReportStatus.selectedReportData.name
});
// map actions
const mapDispatchToProps = dispatch => ({
    getClientReportsData: accountUUID => dispatch(getClientReportsData(accountUUID)),
    removeMessage: (filterProp, filterVal, messageType, alignment) => dispatch(removeMessage(filterProp, filterVal, messageType, alignment)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Reports));
